import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./AuthProvider";
import { Provider } from "react-redux";
import store, { persistor } from "./store.js";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <AuthProvider>
          <App />
          <ToastContainer />
        </AuthProvider>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
reportWebVitals();
